import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { createCheckout, createEnrollment } from '../../../actions/coachCertificationActions'
import { displayWithCurrency } from '../../../utility/currency'
import { sectionsPath } from '../../../utility/coachCertification'
import Button from './Button'
import CouponField from './CouponField'

import classes from './PriceCard.module.scss'

const PriceCardPurchase = ({ certification }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { price } = certification
  const [coupon, setCoupon] = useState(null)
  const [error, setError] = useState(null)
  const [isPurchasing, setIsPurchasing] = useState(false)
  const amount = Number(coupon ? coupon.amount : price?.amount)

  useEffect(() => {
    const restore = (event) => { if (event.persisted) { setIsPurchasing(false) } }
    window.addEventListener('pageshow', restore)
    return () => window.removeEventListener('pageshow', restore)
  }, [])

  const handlePurchase = () => {
    setError(null)
    setIsPurchasing(true)
    const params = { certificationId: certification.id, couponCode: coupon?.code || '' }
    const purchase = amount === 0
      ? dispatch(createEnrollment(params)).unwrap().then(() => navigate(sectionsPath(certification.id)))
      : dispatch(createCheckout(params)).unwrap().then(({ checkout }) => window.location.assign(checkout.url))
    purchase.catch((errors) => {
      if (errors?.coupon) { setCoupon(null) }
      setError(errors?.base?.[0] || errors?.coupon?.[0] || errors?.general?.[0] || t('common.somethingWentWrong'))
      setIsPurchasing(false)
    })
  }

  return (
    <div>
      {price
        ? (
          <div className={classes.price}>
            {displayWithCurrency(amount, price.currency)}
            {coupon && <s className={classes.listPrice}>{displayWithCurrency(price.amount, price.currency)}</s>}
          </div>
        )
        : <div className={classes.stateTitle}>{t('portal.certification.priceCard.noPrice')}</div>}
      <p className={classes.note}>{t('portal.certification.priceCard.oneTime')}</p>
      {price && <CouponField certificationId={certification.id} coupon={coupon} onChange={(value) => { setCoupon(value); setError(null) }} />}
      {error && <p className={classes.purchaseError}>{error}</p>}
      <Button className='d-flex justify-content-center w-100 mb-4' onClick={handlePurchase} disabled={!price} loading={isPurchasing}>
        {t(amount === 0 ? 'portal.certification.priceCard.completeEnrollment' : 'portal.certification.priceCard.purchase')}
      </Button>
    </div>
  )
}

PriceCardPurchase.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    price: PropTypes.shape({
      amount: PropTypes.string.isRequired,
      currency: PropTypes.shape({ code: PropTypes.string.isRequired, symbol: PropTypes.string.isRequired }).isRequired,
    }),
  }).isRequired,
}

export default PriceCardPurchase
